<template>
  <div class="se-system-wrapper">
    <div
      class="map-tooltip"
      :style="style"
    >
      <p
        :style="{
          'font-size': '14px',
          color: mainColor,
        }"
      >
        {{ info.name }}
      </p>
      <p
        v-for="(item, index) in info.list"
        :key="index"
      >
        {{ item.name }}：<span :style="{'color': textStyle.color}">{{ item.val }}</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tooltip',
  props: {
    info: {
      type: Object
    },
    scaleX: {
      type: Number
    },
    scaleY: {
      type: Number
    },
    mainColor: {
      type: String,
      default: ''
    },
    backgroundColor: {
      type: String,
      default: ''
    },
    textStyle: {
      type: Object,
      default: () => ({
        fontColor: '#FFFFFF',
        fontSize: 10
      })
    }
  },
  data() {
    return {
    }
  },
  computed: {
    style() {
      return {
        left: `${(this.info.x * this.scaleX / 0.8)}px`,
        top: `${(this.info.y * this.scaleY / 0.8)}px`,
        width: `${this.info.w}px`,
        height: `${this.info.h}px`,
        background: this.backgroundColor,
        fontSize: `${this.textStyle.fontSize}px`,
        color: this.mainColor,
        zoom: 0.8
      }
    }
  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped>
.map-tooltip{
    position: absolute;
    color: #ffffff;
    cursor: pointer;
    background: rgba(19, 101, 205, 0.5);
    border-radius: 0px;
    padding: 12px;
    opacity: 0;
    transition: all ease-in-out .4s;
    z-index: 999;
}
.se-system-wrapper{
    &:hover{
        .map-tooltip{
            opacity: 1;
        }
    }
}
</style>
